import {
  Box,
  Flex,
  Link,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  Spinner,
  Td,
  Tr,
  Grid,
  useOutsideClick
} from "@chakra-ui/react";
import { formatDisplayDateOnly } from "../helpers/timestamp-display-helper";
import { FiExternalLink } from "react-icons/fi";
import { useRef, useState } from "react";
import { RiDeleteBin2Line } from "react-icons/ri";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MdOutlineDragIndicator } from 'react-icons/md';
import { MdModeEdit } from 'react-icons/md';

export const TableViewSharedDocCard = ({
  isDsrAdmin,
  docId,
  docName,
  docDescription,
  docSharedAt,
  formattedDocLink,
  memberName,
  fileKey,
  showDeleteSpinner,
  showPopoverDocId,
  setShowPopoverDocId,
  handleDeleteSharedDoc,
  handleEditSharedDoc,
  isOpen,
  onOpen,
  onClose,
  isArchivedDsr
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: docId });
  
  const sortableStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? "100" : "auto",
    opacity: isDragging ? 0.3 : 1,
  };

  const [showOptions, setShowOptions] = useState(false)
  const tabRef = useRef(null);

  useOutsideClick({
    ref: tabRef,
    handler: () => setShowPopoverDocId(""),
  })

  if (isArchivedDsr) {
    return (
       <>
    <Tr key={docId} py="0.2em" 
    ref={setNodeRef} 
    style={sortableStyle}
    borderBottom="none"
    onMouseOver={()=>isDsrAdmin && setShowOptions(true)}
    onMouseOut={()=>isDsrAdmin && setShowOptions(false)}
    >

       {/* Column 2 - Nested Grid for Two Rows */}
       <Td colSpan={4}>
        <Grid templateRows="auto 1fr" gap={2}>
          {/* Row 1: 4 Columns */}
          <Grid templateColumns="3fr 1fr 1fr" gap={4} alignItems="center">
       
            <Link href={formattedDocLink} lineHeight="1.625em" fontSize="1.125em" isExternal>
              <Box className="truncate-long-text" maxW="22em">
                {docName}
              </Box>
            </Link>
      
            <Box lineHeight="1.625em">{memberName}</Box>
            <Box lineHeight="1.625em">{formatDisplayDateOnly(docSharedAt)}</Box>
          </Grid>

          {/* Row 2: Full-Width Text */}
          {docDescription &&
          <Box color='gray.500' mt='0.25em' fontStyle='italic' whiteSpace='pre-wrap' pr='1em' >
            {docDescription}
          </Box>
}
        </Grid>
      </Td>
    </Tr>
    </>
    )
  }

  return (
    <>
    <Tr key={docId} py="0.2em" 
    ref={setNodeRef} 
    style={sortableStyle}
    borderBottom="none"
    onMouseOver={()=>isDsrAdmin && setShowOptions(true)}
    onMouseOut={()=>isDsrAdmin && setShowOptions(false)}
    >
      <Td {...listeners} {...attributes} cursor='grab' alignContent={'baseline'}>
        {isDsrAdmin && <Box as={MdOutlineDragIndicator} color={'gray.500'} boxSize="1em" mt='0.35em' mx='0.25em' />}
      </Td>

       {/* Column 2 - Nested Grid for Two Rows */}
       <Td colSpan={4}>
        <Grid templateRows="auto 1fr" gap={2}>
          {/* Row 1: 4 Columns */}
          <Grid templateColumns="3fr 1fr 1fr 1fr" gap={4} alignItems="center">
       
            <Link href={formattedDocLink} lineHeight="1.625em" fontSize="1.125em" isExternal>
              <Box className="truncate-long-text" maxW="22em">
                {docName}
              </Box>
            </Link>
      
            <Box lineHeight="1.625em">{memberName}</Box>
            <Box lineHeight="1.625em">{formatDisplayDateOnly(docSharedAt)}</Box>
            <Flex justify="center" align="center" lineHeight="1.625em">
              {showDeleteSpinner && showPopoverDocId === docId ? (
                <Spinner color="brand.500" />
              ) : (
                <Flex visibility={!!showOptions ? "visible" : "hidden"}>
                  <Link href={formattedDocLink} fontSize="1.4em" isExternal>
                    <FiExternalLink />
                  </Link>
                  <Box mx="0.5em">
                    <Box
                      as={MdModeEdit}
                      color="gray.500"
                      boxSize="1.4em"
                      py="3%"
                      cursor="pointer"
                      onClick={() =>
                        handleEditSharedDoc({docId, docName, formattedDocLink, fileKey, docDescription})
                      }
                    />
                  </Box>
                  <Popover
                    isOpen={showPopoverDocId === docId && isOpen}
                    onOpen={onOpen}
                    onClose={onClose}
                    placement="right"
                    closeOnBlur={false}
                  >
                    <PopoverTrigger>
                      <Box>
                        <Box
                          as={RiDeleteBin2Line}
                          color="brandPink.500"
                          boxSize="1.4em"
                          cursor="pointer"
                          onClick={() => setShowPopoverDocId(docId)}
                        />
                      </Box>
                    </PopoverTrigger>
                    <PopoverContent p={5}>
                      <PopoverArrow />
                      <Flex w="100%" cursor="pointer" onClick={() => handleDeleteSharedDoc(docId, fileKey)}>
                        <Box color="brandPink.500">Yes, delete</Box>
                      </Flex>
                    </PopoverContent>
                  </Popover>
                </Flex>
              )}
            </Flex>
          </Grid>

          {/* Row 2: Full-Width Text */}
          {docDescription &&
          <Box color='gray.500' mt='0.25em' fontStyle='italic' whiteSpace='pre-wrap' pr='1em' >
            {docDescription}
          </Box>
}
        </Grid>
      </Td>
      {/* <Td>
        <Box w='100%'>
        <Flex textAlign={"left"} direction="column" justify="flex-start">
          <Link
            href={formattedDocLink}
            lineHeight="1.625em"
            fontSize="1.125em"
            isExternal
          >
            <Box className="truncate-long-text" maxW="22em">
              {docName}
            </Box>
          </Link>
        </Flex>
        </Box>
      </Td>
      <Td>{memberName}</Td>
      <Td>{formatDisplayDateOnly(docSharedAt)}</Td>
      <Td>
        <Flex justify="center" align="center">
          {showDeleteSpinner && showPopoverDocId === docId ? (
            <Spinner color="brand.500" />
          ) : (
            <Flex visibility={!!showOptions ? 'visible' : 'hidden'}>
              <Link
                href={formattedDocLink}
                fontSize="1.4em"
                isExternal
              >
                <FiExternalLink />
              </Link>

         
              <Box mx="0.5em">
                <Box
                  as={MdModeEdit}
                  color={"gray.500"}
                  boxSize="1.4em"
                  py="3%"
                  cursor="pointer"
                  onClick={() => handleEditSharedDoc(docId, docName, formattedDocLink, fileKey)}
                />
              </Box>
       

              <Popover
                isOpen={showPopoverDocId === docId && isOpen}
                // initialFocusRef={firstFieldRef}
                onOpen={onOpen}
                onClose={onClose}
                placement="right"
                closeOnBlur={false}
              >
                <PopoverTrigger>
                  <Box>
                    <Box
                      as={RiDeleteBin2Line}
                      color={"brandPink.500"}
                      boxSize="1.4em"
                      // py="3%"
                      cursor="pointer"
                      onClick={() => setShowPopoverDocId(docId)}
                    />
                  </Box>
                </PopoverTrigger>
                <PopoverContent p={5}>
                  <PopoverArrow />
                  <Flex
                    w="100%"
                    cursor="pointer"
                    onClick={() => handleDeleteSharedDoc(docId, fileKey)}
                  >
                    <Box color="brandPink.500">Yes, delete</Box>
                  </Flex>
                </PopoverContent>
              </Popover>
            </Flex>
          )}
        </Flex>
      </Td> */}
    </Tr>
    </>
  );
};
